import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import default_theme from "assets/themes/themes";

const TOTAL_STEPS = 4;

const StepsFooter = ({ step = 0 }) => {
    const navigate = useNavigate();
    const { projectId } = useParams();

    const goPrevious = () => {
        if (step > 0) {
            navigate(`/workspaces/projects/${projectId}/step-${step - 1}`);
        }
    };

    const goNext = () => {
        if (step < TOTAL_STEPS - 1) {
            navigate(`/workspaces/projects/${projectId}/step-${step + 1}`);
        }
    };


    return (
        <Box
            sx={{
                mt: 8,
                pt: 3,
                borderTop: "1px solid #e0e0e0",
                maxWidth: 900,
                mx: "auto",
                display: "flex",
                justifyContent: "flex-end",
                gap: 2
            }}
        >
            {step > 0 && (
                <Button
                    variant="outlined"
                    onClick={goPrevious}
                    sx={{
                        textTransform: "none",
                        borderColor: default_theme.palette.other.figmaBlue,
                        color: default_theme.palette.other.figmaBlue,
                        "&:hover": {
                            color: default_theme.palette.primary.main,
                            backgroundColor: default_theme.palette.other.figmaBlue
                        }
                    }}
                >
                    Previous Step
                </Button>
            )}

            {step < TOTAL_STEPS - 1 && (
                <Button
                    variant="outlined"
                    onClick={goNext}
                    sx={{
                        borderColor: default_theme.palette.other.figmaBlue,
                        color: default_theme.palette.other.figmaBlue,
                        textTransform: "none",

                        "&:hover": {
                            color: default_theme.palette.primary.main,
                            backgroundColor: default_theme.palette.other.figmaBlue
                        },

                        "&.Mui-disabled": {
                            borderColor: "#e0e0e0",
                            color: "#9e9e9e",
                        }
                    }}
                >
                    Next Step
                </Button>
            )}
        </Box>
    );
};

export default StepsFooter;